"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createProvider = exports.OktaAuthProvider = exports.createMicrosoftADProvider = exports.createOktaProvider = exports.InfoAuthProvider = exports.createInfoAuthProvider = void 0;
var provider_enum_1 = require("../constants/provider.enum");
var aws_auth_provider_1 = require("./aws.auth.provider");
var info_auth_provider_1 = require("./info.auth.provider");
var okta_auth_provider_1 = require("./okta.auth.provider");
var microsoft_ad_auth_provider_1 = require("./microsoft-ad.auth.provider");
var info_auth_provider_2 = require("./info.auth.provider");
Object.defineProperty(exports, "createInfoAuthProvider", { enumerable: true, get: function () { return info_auth_provider_2.default; } });
var info_auth_provider_3 = require("./info.auth.provider");
Object.defineProperty(exports, "InfoAuthProvider", { enumerable: true, get: function () { return info_auth_provider_3.InfoAuthProvider; } });
var okta_auth_provider_2 = require("./okta.auth.provider");
Object.defineProperty(exports, "createOktaProvider", { enumerable: true, get: function () { return okta_auth_provider_2.default; } });
var microsoft_ad_auth_provider_2 = require("./microsoft-ad.auth.provider");
Object.defineProperty(exports, "createMicrosoftADProvider", { enumerable: true, get: function () { return microsoft_ad_auth_provider_2.default; } });
var okta_auth_provider_3 = require("./okta.auth.provider");
Object.defineProperty(exports, "OktaAuthProvider", { enumerable: true, get: function () { return okta_auth_provider_3.OktaAuthProvider; } });
exports.createProvider = function (config) {
    var providerEnum = provider_enum_1.parseAuthProviderEnum(config.provider.type);
    switch (providerEnum) {
        case provider_enum_1.AuthProviderEnum.AWS:
            return aws_auth_provider_1.default(config);
        case provider_enum_1.AuthProviderEnum.INFOAUTH:
            return info_auth_provider_1.default(config);
        case provider_enum_1.AuthProviderEnum.OKTA:
            return okta_auth_provider_1.default(config);
        case provider_enum_1.AuthProviderEnum.MICROSOFT_AD_INFO_APPS:
        case provider_enum_1.AuthProviderEnum.MICROSOFT_AD:
            return microsoft_ad_auth_provider_1.default(config);
        default:
            throw new Error('Invalid or Unsupported Authentication provider configuration: ' + providerEnum);
    }
};
//# sourceMappingURL=index.js.map